import React from 'react'
import { List, TextField, EditButton, useRedirect } from 'react-admin'
import axios from 'axios'
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import legolasApi from '../../api/legolas'


function CustomerGroupsList() {
  const [listData, setListData] = React.useState(null)
  const [totalCount, setTotalCount] = React.useState(null)

  const redirect = useRedirect()
  React.useEffect(() => {
    axios.get(`${legolasApi.url}/customer/admin/usergroup`).then((response) => {
      console.log('user grp res', response)
      if (response && response.data && response.data.userGroups) {
        setListData(response.data.userGroups)
      }
      if (response && Array.isArray(response.data.userGroups) && response.data.userGroups.length) {
        setTotalCount(response.data.userGroups.length)
      }
    })
  },[])

  const redirectToAddGroup = () => {
    redirect('/add-customer-group')
  }

  if (listData == null) {
    return null
  } else {
    return (
      <Box sx={{ height: 'auto', margin: '10px 20px'}}>
        <Box sx={{ display: 'flex'}}>
          <Typography variant='h4'>
            Customer Groups
          </Typography>
          <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
            {totalCount} record(s) found
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 15px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
        }}
        >
          <Button onClick={redirectToAddGroup}>Add New Customer Group</Button>
        </Box>
        <Box>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important'
                }
              }}>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Group</TableCell>
                <TableCell align="center">Tax Class</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableHead>
              <TableBody>
                {listData.map((data) => {
                  return (
                    <TableRow>
                      <TableCell align="center">{data.user_group_id}</TableCell>
                      <TableCell align="center">{data.user_group_code}</TableCell>
                      <TableCell align="center">{data.class_name}</TableCell>
                      <TableCell align="center" sx={{ color: globalStyles.colors.backgroundPrimary, cursor: 'pointer' }}>Edit</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    )
  }
}

export default CustomerGroupsList